<script setup lang="ts">
  import { useWindowSize } from '@vueuse/core'
  import { onMounted } from 'vue'
  import { useState } from '~renderer/composables/useState'

  const { DEV } = import.meta.env
  const { adsEnabled } = useState()
  const { width: innerWidth } = useWindowSize()

  onMounted(() => {
    window.nitroAds.createAd('banner', {
      demo: DEV,
      sizes: [innerWidth.value < 728 ? [320, 50] : innerWidth.value < 970 ? [728, 90] : [970, 90]],
      refreshTime: 60,
      report: {
        enabled: true,
        wording: 'Report Ad',
        position: 'bottom-right',
      },
    })
  })
</script>

<template>
  <div id="banner" v-if="adsEnabled"></div>
</template>
